import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { FaTimes } from "react-icons/fa"
export const MessageAlert = ({ message, handleCloseMessageBox, open,color }) => {
    
    return (
        <Snackbar
            id="snackbar"
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={open}
            autoHideDuration={5000}
            onClose={handleCloseMessageBox}
            ContentProps={{
                'aria-describedby': 'message-id',
            }}
            message={
                <div className={color === "red" ? "red-bg d-flex-space-between" : "green-bg d-flex-space-between" } style={{width:'100%',padding:'20px 15px'}}>
                    <span className="toaster-msg-body">{message}</span>
                    <FaTimes className="mg-left-20 cp" style={{padding:'7px',borderRadius:'50%',fontSize:'30px',border:'2px solid white'}} onClick={handleCloseMessageBox}/>
                </div>
            }
        />
    )
}